import { Box, Text } from '@ui'
import { ToneName } from 'ui/styles/themes'
import { vars } from 'ui/styles/vars.css'
import { type Address } from 'use-towns-client'

import { useAppRenewCountdownData } from './hooks/useAppRenewCountdownData'

export function AppRenewCountdown(props: { spaceId: string; appAddress: Address }) {
    const { spaceId, appAddress } = props
    const { isExpired, daysRemaining, displayWindow, shouldDisplay } = useAppRenewCountdownData({
        spaceId,
        appAddress,
    })

    if (!shouldDisplay) {
        return null
    }

    const progress = isExpired ? 100 : Math.min(100, (daysRemaining / displayWindow) * 100)

    const size = 20
    const strokeWidth = 2
    const radius = (size - strokeWidth) / 2
    const circumference = 2 * Math.PI * radius
    const strokeDashoffset = circumference - (progress / 100) * circumference

    return (
        <Box
            centerContent
            position="relative"
            style={{
                width: size,
                height: size,
            }}
        >
            <Box
                as="svg"
                position="absolute"
                style={{
                    rotate: '-90deg',
                    width: size,
                    height: size,
                }}
            >
                {/* Background circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={vars.color.background.level3}
                    strokeWidth={strokeWidth}
                />
                {/* Progress circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={vars.color.tone[ToneName.Error]}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    style={{
                        transition: 'stroke-dashoffset 0.3s ease, stroke 0.3s ease',
                    }}
                />
            </Box>
            {/* Number in center */}
            <Box centerContent color="error">
                <Text size="xs">{daysRemaining}</Text>
            </Box>
        </Box>
    )
}
